<template>
    <div class="variant-filter-wrapper">
        <div class="filter-actions d-flex align-items-center mb-1">
            <button class="btn btn-primary" @click="toggleFilters">Toggle Filters</button>
            <template v-if="filtersVisible">
                <button class="btn btn-success ml-3" @click="addFilter">
                    <i class="fa fa-plus" />
                    Add Filter
                </button>
                <button class="btn btn-info mx-2" :disabled="isSearchDisabled" @click="search">
                    <i class="fa fa-search" />
                    Search
                </button>
                <button class="btn btn-danger" :disabled="!addedFilters.length || disableActions" @click="clearFilter">
                    <i class="fa fa-trash" />
                    Clear Filters
                </button>
            </template>
        </div>
        <b-collapse id="variantFilters" v-model="filtersVisible">
            <div class="card card-body py-2">
                <template v-if="addedFilters.length">
                    <div
                        v-for="(filter, idx) of addedFilters"
                        :key="`filter-${idx}`"
                        class="d-flex align-items-start my-1"
                    >
                        <v-select
                            v-model="filter.selectedFilter"
                            class="w-50"
                            label="name"
                            placeholder="Select filter type"
                            :options="filters"
                            @option:selected="onFilterTypeDeselected(filter)"
                        />
                        <v-select
                            v-if="filter.selectedFilter"
                            v-model="filter.selectedValues"
                            class="ml-3 w-50"
                            :multiple="allowMultipleSelect"
                            label="name"
                            placeholder="Select values"
                            :options="filter.selectedFilter.values"
                            :reduce="(option) => option.value"
                            :close-on-select="false"
                        />
                    </div>
                </template>
                <div v-else class="text-center">No Filters</div>
            </div>
        </b-collapse>
    </div>
</template>

<script lang="ts" setup>
import { Ref, computed, ref } from 'vue';
import { ProductFilters } from '@/api/typings/podProviders';
import vSelect from 'vue-select';

const emit = defineEmits(['search']);

const props = withDefaults(
    defineProps<{
        filters: ProductFilters[];
        disableActions?: boolean;
        allowMultipleSelect?: boolean;
    }>(),
    {
        allowMultipleSelect: true
    }
);

const filtersVisible = ref(false);
const addedFilters: Ref<any[]> = ref([]);

const isSearchDisabled = computed(() => {
    return props.disableActions || addedFilters.value.every((filter) => filter.selectedValues?.length == 0);
});

const addFilter = () => {
    addedFilters.value.push({
        selectedFilter: null,
        selectedValues: []
    });
};

const search = () => {
    const params: { [key: string]: string[] } = {};

    for (const filter of addedFilters.value) {
        if (!filter.selectedValues?.length || !filter.selectedFilter?.id) return;
        params[filter.selectedFilter.id] = Array.isArray(filter.selectedValues)
            ? [...filter.selectedValues]
            : [filter.selectedValues];
    }

    emit('search', params);
};

const clearFilter = () => {
    addedFilters.value = [];
    emit('search');
};

const onFilterTypeDeselected = (filter: any) => {
    filter.selectedValues = [];
};

const toggleFilters = () => {
    filtersVisible.value = !filtersVisible.value;
};
</script>

<style lang="scss" scoped>
.variant-filter-wrapper {
    #variantFilters::v-deep {
        .v-select {
            background: unset;
            .vs__dropdown-toggle {
                max-height: unset;
            }
        }
    }
}
</style>
